// The game identifier is also the product ID in Google Play and the App Store
// (see PurchaseService in doublehealix-app-cardgame), so it follows the
// strictest store rule: lowercase letters, digits, '.' and '_', starting with
// a letter or digit. Same rule as the API (StoreGameRequest / UpdateGameRequest).
export const GAME_IDENTIFIER_PATTERN = /^[a-z0-9][a-z0-9._]*$/;
export const GAME_IDENTIFIER_MAX_LENGTH = 100;

// games.price is decimal(10, 2).
export const GAME_PRICE_MIN = 0;
export const GAME_PRICE_MAX = 99999999.99;

export function isValidGameIdentifier(identifier: string): boolean {
  return (
    typeof identifier === 'string' &&
    identifier.length <= GAME_IDENTIFIER_MAX_LENGTH &&
    GAME_IDENTIFIER_PATTERN.test(identifier)
  );
}

export function isValidGamePrice(price: any): boolean {
  if (price === '' || price === null || price === undefined) return false;
  const value = Number(price);
  return Number.isFinite(value) && value >= GAME_PRICE_MIN && value <= GAME_PRICE_MAX;
}
